import fp from 'lodash/fp';
import { bindActionCreators } from 'redux';
import actions from '../state/actions';

export const eventValueHandler = (handler) =>
  ({ target: { value } }) => handler(value)

export const mapDispatchToProps = (actionMap) =>
  (dispatch) => fp.mapValues(
    (value) => bindActionCreators(value, dispatch)
  )(actionMap(actions))



// WEBPACK FOOTER //
// ./src/common/utils.js